import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppointmentsDate from './AppointmentsDate';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

AppointmentsWrapper.propTypes = {
    selectedClinic: PropTypes.string,
    services: PropTypes.string,
    defaultPeople: PropTypes.number,
};

export default function AppointmentsWrapper({
    selectedClinic = '',
    services = '',
    defaultPeople = 1,
}) {
    const today = new Date();
    today.setHours(23,0,0,0);
    const [people, setPeople] = useState(defaultPeople);
    const [appointments, setAppointments] = useState(null);
    const [startDate, setStartDate] = useState(new Date().setHours(0,0,0,0));
    const [endDate, setEndDate] = useState(today.setDate(today.getDate() + 6));
    const [prevEndDate, setPrevEndDate] = useState(endDate);
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState(null);
    const [page, setPage] = useState(1);

    const onChange = (dates) => {
        const [start, end] = dates;
        start.setHours(0,0,0,0);
        if (end) {
            end.setHours(23,59,59,59);
        }
        setStartDate(start);
        setPrevEndDate(endDate);
        setEndDate(end);
    };

    function handleLoadMore(e) {
        e.preventDefault();
        const curEndDate = new Date(endDate);
        setEndDate(curEndDate.setDate(curEndDate.getDate() + 7));
        setLoading(true);
        fetch(`/cd/feeds/booking-journey/appointments/${selectedClinic}/${services}/${people}/${page + 1}`)
            .then(response => response.json())
            .then(data => {
                const newData = {...appointments, ...data};
                setAppointments(Object.keys(newData).sort().reduce((obj, key) => { 
                    obj[key] = newData[key]; 
                    return obj;
                }, {}));
            })
            .catch(error => alert('There has been an error fetching appointments'))
            .finally(() => {
                setLoading(false);
                setPage(page + 1);
            });
    }

    useEffect(() => {
        if (!people) {
            return;
        }
        setLoading(true);
        fetch(`/cd/feeds/booking-journey/appointments/${selectedClinic}/${services}/${people}/1`)
        .then(response => response.json())
        .then(data => {
            setAppointments(data);
        })
        .catch(error => {
            alert('There has been an error fetching appointments');
        })
        .finally(() => {
            setSelectedDate(null);
            setPage(1);
            setLoading(false);
        });
    }, [people]);

    // useEffect(() => {
    //     if (!loading) return;
    //     const scrollable = document.querySelector('[data-behaviour="scroll-appointments"]');
    //     if (!scrollable);
    //     scrollable.scrollTo(0, scrollable.offsetHeight);
    // }, [loading]);

    useEffect(() => {
        document.addEventListener('select-people', (e) => {
            setPeople(e.detail);
        });
    }, []);

    let hasResults = false;

    const printDates = (type) => {
        
        let from = prevEndDate;
        let to = endDate;
        
        if (type === 'previous') {
            from = startDate;
            to = prevEndDate;
        }

        return ({id, ...rest}) => {
            const date = new Date(id);
            if (date >= from && date <= to) {
                hasResults = true;
                return <AppointmentsDate key={id} date={id} entry={rest} onSelectDate={setSelectedDate} selectedDate={selectedDate} />
            }
        }
    }

    return (
        <div className="appointmentsWrapper">
            {/*
                <DatePicker 
                    selectsRange
                    toggleCalendarOnIconClick
                    selected={startDate}
                    onChange={onChange} 
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    minDate={new Date()}
                    calendarStartDay={1}
                    showIcon
                    icon={<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 2.5H3C1.89543 2.5 1 3.39543 1 4.5V18.5C1 19.6046 1.89543 20.5 3 20.5H17C18.1046 20.5 19 19.6046 19 18.5V4.5C19 3.39543 18.1046 2.5 17 2.5Z" stroke="#213163" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 0.5V4.5" stroke="#213163" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M6 0.5V4.5" stroke="#213163" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M1 8.5H19" stroke="#213163" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    }
                    customInput={<input className="react-datepicker-ignore-onclickoutside" type="text" inputMode="none" />}
                />
            */}
            {people > 0 && appointments && (
                <div className={`appointmentsWrapper__inner ${loading ? 'appointmentsWrapper__inner--loading' : ''}`} data-behaviour="scroll-appointments">
                    {Object.keys(appointments).map((key) => ({
                        id: key,
                        ...appointments[key]
                    })).map(printDates('previous'))}
                    <a id="appointments-anchor" />
                    {Object.keys(appointments).map((key) => ({
                        id: key,
                        ...appointments[key]
                    })).map(printDates('next'))}
                    {hasResults && <a href="#" onClick={handleLoadMore} className="appointmentsWrapper__more">Show More</a>}
                    {!loading && !hasResults && (
                        <>
                            <p className="appointmentsWrapper__message">No appointments available in this date range.</p>
                            <a href="#" onClick={handleLoadMore} className="appointmentsWrapper__more">Search next 7 days</a>
                        </>
                    )}
                </div>
            )}
            {!people && <p className="appointmentsWrapper__message">Please select the number of people wishing to attend.</p>}
        </div>
    );
}